<template>
  <div class="obituary-threaded-comments__form-toggle">
    <button
      class="obituary-comments__input-button"
      @click.prevent="showComments"
    >
      <img :src="iconSrc">
      {{ texts.threadedComments.writeAComment }}
    </button>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  export default {
    name: "ThreadedCommentsFormToggle",

    props: {
      parent: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        iconSrc: `${theme_vars.assetsUrl}/images/illustrations/pen.svg`,
        texts: lavendlaObituary,
      };
    },

    computed: {
      ...mapGetters("global", ["isMobile"]),
    },

    methods: {
      ...mapMutations("threadedComments", ["setModalContext", "setParent"]),
      ...mapActions("threadedComments", ["toggleModal"]),

      showComments() {
        if (this.isMobile && this.parent) {
          this.setParent(this.parent);
          this.toggleModal("create");
          return;
        }

        this.setModalContext("create");
      },
    },
  };
</script>
